var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 2.75V1.25C17.75 0.835784 18.0718 0.5 18.4688 0.5C18.8657 0.5 19.1875 0.835789 19.1875 1.25V2H19.9062C20.3528 2 20.728 2.31869 20.8344 2.75H21.1797C21.8393 2.75 22.8935 3.21845 23.0535 3.8862L23.5 5.75C23.5 6.16423 23.1782 6.5 22.7812 6.5C22.3843 6.5 22.0625 6.16423 22.0625 5.75H19.9062C19.9062 5.75 19.1884 10.6606 18.4688 11.75C17.5675 13.1141 15.5938 14 15.5938 14V20.375C15.5938 20.9963 15.1111 21.5 14.5156 21.5H13.7969C13.2014 21.5 12.7188 20.9963 12.7188 20.375V14H6.25L5.58763 17.4558C5.55043 17.65 5.55043 17.85 5.58763 18.0442L6.07804 20.6029C6.16703 21.067 5.82684 21.5 5.37326 21.5H4.25885C3.74493 21.5 3.30245 21.1215 3.20166 20.5956L2.71263 18.0442C2.67541 17.85 2.67541 17.65 2.71263 17.4558L3.375 14L1.9375 10.25L0.5 13.25V10.25C0.5 8.59316 1.78718 7.25 3.375 7.25L4.12945 5.98039C5.04587 4.4382 6.66126 2.75 8.40028 2.75C10.1268 2.75 11.7325 3.67489 12.6526 5.19941C13.7013 6.93702 12.9194 8 14.875 8C16.2558 7.73802 17.75 2.75 17.75 2.75Z",
    fill: "#118f84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamel);
export default __webpack_public_path__ + "static/media/CAMEL.e224ad5e3d92bd577d62fe85209868ff.svg";
export { ForwardRef as ReactComponent };